const actions = {
GET_LIVE_STOCK:"GET_LIVE_STOCK",
SET_LIVE_STOCK:"SET_LIVE_STOCK"   
}
export default actions;